export default __webpack_public_path__ + "static/media/6.6b4b734d.jpg";